import { Action } from '@ngrx/store'
import { ItemMenu } from '../dominios/item-menu'

// Section 2
export const ADD_ITEM_MENU       = '[ITEM_MENU] Add'
export const CLEAR_ITEM_MENU    = '[ITEM_MENU] Clear'

// Section 3
export class AddItemMenu implements Action {
    readonly type = ADD_ITEM_MENU

    constructor(public payload: ItemMenu[]) {}
}

export class ClearItemMenu implements Action {
    readonly type = CLEAR_ITEM_MENU

    constructor(public payload: ItemMenu[]) {}
}

// Section 4
export type Actions = AddItemMenu | ClearItemMenu



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/actions/item-menu.action.ts